import axios from "axios";
import authHeader from "./auth-header";
import IAccount from "../types/account.type";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/account`;

export const getById = (id: string) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (account: IAccount) => {
  return axios.post(API_URL, account, { headers: authHeader() });
};

export const update = (id: number, account: IAccount) => {
  return axios.put(API_URL + "/" + id, account, { headers: authHeader() });
};

export const getAccounts = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};

export const getActiveAccounts = () => {
  return axios.get(API_URL + "/actives", { headers: authHeader() });
};